import { timeYear, timeMonth, timeWeek } from "d3";
import {
  formatTimeYear,
  formatTimeMonthYear,
  formatTimeDayMonthYear,
  LAYOUT,
} from "../../utils";

export const textFormatFromZoomLevel = (scaleX = 1) => {
  const zoomFormats = [
    {
      quantize: timeYear,
      format: formatTimeYear,
      scaleX: 1,
      fontSize: LAYOUT.TIMELINE.AXIS.VERTICAL.FONT_SIZE * 0.75,
      dy: 0,
    },
    {
      quantize: timeMonth,
      format: formatTimeMonthYear,
      scaleX: 4,
      fontSize: LAYOUT.TIMELINE.AXIS.VERTICAL.FONT_SIZE * 0.5,
      dy: 0,
    },
    {
      quantize: timeWeek,
      format: formatTimeDayMonthYear,
      scaleX: 12,
      fontSize: LAYOUT.TIMELINE.AXIS.VERTICAL.FONT_SIZE * 0.5,
      dy: -0.25,
    },
  ];
  return zoomFormats.reduce((acc, curr) => {
    return curr.scaleX <= scaleX ? curr : acc;
  }, zoomFormats[0]);
};
